export const REGIE_TIMEENTRIES_INDEX = 'REGIE_TIMEENTRIES_INDEX'
export const REGIE_ARTICLEENTRIES_INDEX = 'REGIE_ARTICLEENTRIES_INDEX'
export const REGIE_TIMEENTRIES_ADD = 'REGIE_TIMEENTRY_ADD'
export const REGIE_ARTICLEENTRIES_ADD = 'REGIE_ARTICLEENTRY_ADD'
export const REGIE_SAVE = 'REGIE_SAVE'
export const REGIE_RESET = 'REGIE_RESET'
export const REGIE_SET_CUSTOMER = 'REGIE_SET_CUSTOMER'
export const REGIE_SET_PROJECT = 'REGIE_SET_PROJECT'
export const REGIE_SET_DESCRIPTION = 'REGIE_SET_DESCRIPTION'
export const REGIE_INDEX = 'REGIE_INDEX'
export const REGIE_GET = 'REGIE_GET'
export const REGIE_CURRENT = 'REGIE_CURRENT'
export const REGIE_GETWORKERS = 'REGIE_GETWORKERS'



// WEBPACK FOOTER //
// ./src/store/actions/regie.js